/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-08 23:33:24
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-10 17:10:21
 * @FilePath: /lobby/src/stores/lobby.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { url } from '@/common/config.js'
import { Key, setLocalStorage } from '@/common/localStorage'
import { post } from '@/common/request.js'
// import { WSController } from '@/server/pp_game_socket_controller'
import { useUserStore } from '@/stores/user.js'
import { getMobileOperatingSystem } from '@/utils/helper'
import { defineStore } from 'pinia'
import { showLoadingToast } from 'vant'
import { useRoute } from 'vue-router'

export const SPORT_NAV_TAB_TYPE = 'sports'
export const GAME_NAV_TAB_TYPE = 'games'

export const useLobbyStore = defineStore('lobby', {
  state: () => {
    return {
      bannersHomeTop: [],
      categories: [],
      recommend: [],
      functionTabs: [],
      functionTabIndex: 0,
      collectGameId: -1,
      bonusGamecategory: null,
      currentGameIsBonus: null,
      hasPopup: false,
      hasStickyBanner: false,
      allBanner: {},
      showdownloadBen: true,
      navtabType: SPORT_NAV_TAB_TYPE
    }
  },
  getters: {
    checkShowAPPDownloadBanner() {
      const checkCid = localStorage.getItem('cid')
      if (checkCid && (checkCid == 'etAPP16' || checkCid == 'keAPP16')) {
        return false
      }
      const route = useRoute()
      if (route && route.name !== 'home') {
        return false
      }
      return (
        (this.country == 'ET' || this.country == 'KE') &&
        __APP_ENV__ !== 'app' &&
        __APP_ENV__ !== 'app_staging' &&
        this.showdownloadBen
      )
    },
    country() {
      return useUserStore().country
    },
    app_env() {
      return import.meta.env.VITE_APP_ENV == 'app' ? 'app' : 'h5'
    },
    functionList() {
      if (this.categories.length > 0) {
        console.log('functionList', this.categories)
        /**排序 */
        //Home
        // var list = [{ name: 'Home', cover: 'bi-house' }]
        const fillterGameList = this.categories.filter((itme) => {
          return itme.isFunction
        })
        const hotitem = fillterGameList.find((item) => {
          return item.name == 'Hot'
        })
        var list = [
          { name: 'Home', cover: 'bi-house', id: hotitem.id, localName: hotitem.localName }
        ]
        return list.concat(
          fillterGameList.sort((a, b) => {
            return b.functionWeight - a.functionWeight
          })
        )
      }
      return []
    },
    hotGame() {
      if (this.categories.length > 0) {
        console.log('functionList', this.categories)
        const fillterGameList = this.categories.filter((item) => {
          return item.name == 'HOT' || item.name == 'Hot'
        })
        return fillterGameList[0]
      }
      return null
    },
    bonusGamesID() {
      if (this.bonusGamecategory) {
        return this.bonusGamecategory.id
      } else {
        return localStorage.getItem(Key.BonusGamesID)
      }
    }
  },
  actions: {
    updatecollectGameId(id) {
      this.collectGameId = id
    },
    updateLobby() {
      return new Promise((resolve, reject) => {
        this.getBannersHomeTop()
          .then((r) => {
            this.bannersHomeTop = r.banners
            this.getCategories()
              .then((r) => {
                this.categories = r.categories

                // new WSController()
                //   .configure(config.env, config.pp_game_ws)
                //   .addTable('table1')
                //   .addTable('table2')
                //   .setTableCallback('table1', (data) => {
                //     console.log('Table1 specific data:', data)
                //   })
                //   .connectAndSubscribe(
                //     config.env,
                //     'casino123',
                //     useUserStore().balance.currency,
                //     true
                //   )
                this.functionTabIndex = 0
                this.functionTabs = this.categories
                  .filter((value) => {
                    return value.isFunction
                  })
                  .sort((a, b) => {
                    return b.functionWeight - a.functionWeight
                  })

                this.recommend = this.categories
                  .filter((value) => {
                    return value.isRecommend
                  })
                  .sort((a, b) => {
                    return b.recommendWeight - a.recommendWeight
                  })

                this.bonusGamecategory = this.categories.find((item) => {
                  return item.name == 'Bonus'
                })
                localStorage.setItem(Key.BonusGamesID, this.bonusGamecategory.id)
                resolve()
              })
              .catch(() => {
                reject()
              })
          })
          .catch(() => {
            reject()
          })
      })
    },
    selectFunctionTab(index = 0) {
      this.functionTabIndex = index
    },
    batchBanners() {
      return post(url.lobby.batchBanners, {
        country: this.country
      }).then((r) => {
        // 将横幅广告按照 position 分类存储到 allBanner 对象中
        const allBanner = {}
        r.banners.forEach((banner) => {
          if (!allBanner[banner.position]) {
            allBanner[banner.position] = []
          }
          allBanner[banner.position].push(banner)
        })
        // 将分类后的横幅广告存储到 state 中
        this.allBanner = allBanner
        return this.allBanner
      })
    },
    /**
     * 根据位置获取横幅广告
     * @param {string} position - 横幅广告的位置标识
     * @returns {Array} - 返回指定位置的横幅广告数组，如果没有则返回空数组
     */
    getBannersByPosition(position) {
      // 如果allBanner为空，则先获取横幅广告数据
      return new Promise((resolve, reject) => {
        if (!this.allBanner || !this.allBanner[position]) {
          this.batchBanners()
            .then(() => {
              resolve(this.allBanner[position] || [])
            })
            .catch(() => {
              reject()
            })
        } else {
          resolve(this.allBanner[position] || [])
        }
      })
    },
    getBannerByCountryAndPOsition(country, position) {
      return post(url.lobby.banners, { country, position }).then((r) => {
        return r.banners || []
      })
    },
    getBannersHomeTop(position = 'home_top') {
      if (position == 'sticky_banner') {
        const nowTime = new Date()
        let time =
          nowTime.getUTCFullYear().toString() +
          nowTime.getUTCMonth().toString() +
          nowTime.getUTCDate().toString()
        if (time != localStorage.getItem(Key.StickyBanner)) {
          const sticky_banner = this.allBanner[position] || []
          this.hasStickyBanner = sticky_banner.length > 0
        }
      }
      return Promise.resolve({ banners: this.allBanner[position] || [] })
      // else {
      //   console.log('getBannersHomeTop', position, this.allBanner)
      //   return this.batchBanners().then((r) => {
      //     if (position == 'sticky_banner') {
      //       const nowTime = new Date()
      //       let time =
      //         nowTime.getUTCFullYear().toString() +
      //         nowTime.getUTCMonth().toString() +
      //         nowTime.getUTCDate().toString()
      //       if (time != localStorage.getItem(Key.StickyBanner)) {
      //         const sticky_banner = r[position] || []
      //         this.hasStickyBanner = sticky_banner.length > 0
      //       }
      //     }
      //     return { banners: r[position] || [] }
      //   })
      // }
      // return post(url.lobby.banners, {
      //   country: this.country,
      //   position
      // }).then((r) => {
      // if (position == 'sticky_banner') {
      //   const nowTime = new Date()
      //   let time =
      //     nowTime.getUTCFullYear().toString() +
      //     nowTime.getUTCMonth().toString() +
      //     nowTime.getUTCDate().toString()
      //   if (time != localStorage.getItem(Key.StickyBanner)) {
      //     this.hasStickyBanner = r.banners && r.banners.length > 0
      //   }
      // }
      //   return r
      // })
    },
    hideStickyBanners() {
      this.hasStickyBanner = false
      const nowTime = new Date()
      let time =
        nowTime.getUTCFullYear().toString() +
        nowTime.getUTCMonth().toString() +
        nowTime.getUTCDate().toString()
      localStorage.setItem(Key.StickyBanner, time)
    },
    hideDownloadAppBanner() {
      this.showdownloadBen = false
    },
    getCategories() {
      return post(url.game.categories, {
        country: this.country
      })
    },
    /**
     * 获取游戏列表
     * @param {*} category 分类
     * @param {*} gameplayTag 游戏玩法标签，用于筛选，全部玩法传空字符串
     * @param {*} pageNum 页号
     * @param {*} pageSize 每页大小
     * @returns
     */
    getGameList(id = 0, gameplayTag = '', pageNum = 1, pageSize = 20) {
      return post(url.game.list, {
        country: this.country,
        category: parseInt(id),
        gameplayTag,
        pageNum,
        pageSize
      })
    },
    enterGame(gameId) {
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 2000
      })
      return new Promise((resolve, reject) => {
        post(url.game.enter, { gameId })
          .then((res) => {
            this.currentGameIsBonus = res.isBonus
            setLocalStorage(Key.isBonus, res.isBonus)
            resolve(res)
          })
          .catch((reason) => {
            reject(reason)
          })
      })
    },
    favorite(gameId, opt) {
      if (!gameId) {
        gameId = this.collectGameId
      }
      if (gameId >= 0) {
        return post(url.game.favorite, { gameId, opt })
      } else {
        return Promise.resolve()
      }
    },
    /**
     * 下注记录
     * @param {Boolean} isBonus 是否查询bonus下注
     * @param {Number} pageNum
     * @param {Number} pageSize
     * @returns
     */
    records(isBonus = false, pageNum = 1, pageSize = 999, endDate = '', startDate = '') {
      return post(url.game.records, { isBonus, pageNum, pageSize, endDate, startDate })
    },
    notice() {
      return post(url.notice.list, { country: this.country })
    },
    popup() {
      return post(url.popup, {
        country: this.country,
        system: getMobileOperatingSystem(),
        terminal: this.app_env
      }).then((r) => {
        this.hasPopup = r.popUps && r.popUps.length > 0
        console.log('11111=>>>>>>>>', this.hasPopup)
        return r
      })
    },
    hidePopup() {
      this.hasPopup = false
    },
    getPromotionsBanners() {
      return post(url.lobby.promotionsBanners, {
        country: this.country
      })
    }
  }
})
